module.exports = __webpack_public_path__ + "static/media/6.f420c599.png";